/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { Button, Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import { Dimensions, Image, TouchableOpacity, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import { useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Icon from "@expo/vector-icons/MaterialIcons"
import flash from "config/flash"
import { colors } from "colors"
import moment from "moment-timezone"

import exmaple from "../../../../assets/coffee-banner.jpg"
import { MaterialCommunityIcons } from "@expo/vector-icons"
import LinearGradient from "react-native-linear-gradient"

export const RewardDetailScreen = () => {
  const navigation = useNavigation<any>()
  const route = useRoute()
  const { routeFrom, item }: any = route?.params || {}
  const { height, width } = useWindowDimensions()
  const [data] = useState(item)

  return (
    <>
      <Screen preset="scroll" contentContainerStyle={style.scrollContent}>
        <View>
          <View>
            <Image
              source={{
                uri: exmaple,
              }}
              resizeMode="stretch"
              style={[style.image, { height: width * 0.6, maxHeight: height * 0.4 }]}
            />
            <TouchableOpacity onPress={() => navigation.goBack()} style={style.headerLeftButton}>
              <Icon name="arrow-back" size={28} color="white" />
            </TouchableOpacity>
          </View>
          <View style={style.container}>
            <Text style={style.title}>{data?.rewardTitle}</Text>

            <View style={{ display: "flex" }}>
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  marginVertical: 10,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <View style={style.starbox}>
                  {Array.from({ length: item.totalRewards })
                    .reduce((rows: any, _, index) => {
                      if (index % 5 === 0) rows?.push([])
                      rows[rows?.length - 1].push(index)
                      return rows
                    }, [])
                    .map((row: any, rowIndex: number) => (
                      <View
                        key={rowIndex}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          marginVertical: 10,
                        }}
                      >
                        {row.map((index) => (
                          <View
                            key={index}
                            style={{
                              backgroundColor: "#D3D3D3",
                              width: 30,
                              height: 30,
                              marginRight: 10,
                              borderRadius: 15, // 50% of width/height for a perfect circle
                              alignItems: "center",
                              justifyContent: "center",
                              borderWidth: 1,
                              borderColor: index < item.receivedReward ? "#FFD700" : "black",
                              borderStyle: "dashed",
                              position: "relative", // For positioning sparkle icons
                            }}
                          >
                            {index < item.receivedReward ? (
                              <LinearGradient
                                colors={["#FFFACD", "#FFD700", "#FFC107"]}
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  borderRadius: 15,
                                }}
                              />
                            ) : (
                              <View
                                style={{
                                  backgroundColor: "#fefef4",
                                  position: "absolute",
                                  borderRadius: 15,
                                }}
                              />
                            )}
                            <Text
                              style={[
                                style.tierSpendText,
                                { color: "#000", zIndex: 998, marginTop: 0 },
                              ]}
                            >
                              {index + 1}
                            </Text>
                            {index < item.receivedReward && (
                              <>
                                <MaterialCommunityIcons
                                  name="star-four-points"
                                  size={8}
                                  color="#FFFFE0"
                                  style={{ position: "absolute", top: 3, left: 3 }}
                                />
                                <MaterialCommunityIcons
                                  name="star-four-points"
                                  size={6}
                                  color="#FFFACD"
                                  style={{ position: "absolute", bottom: 5, right: 5 }}
                                />
                              </>
                            )}
                          </View>
                        ))}
                      </View>
                    ))}
                </View>
                <View style={style.cutoutLeft} />
                <View style={style.cutoutRight} />
                <View style={style.cutoutCenter} />
              </View>
              <Text style={[style.tierSpendText, { flex: 1 }]}>
                You have collected ({data?.receivedReward}/{data?.totalRewards}) stamps
              </Text>
            </View>
          </View>
          {/* Sticky bottom */}
        </View>
      </Screen>
      <View
        style={[
          style.stickyBottomContainer,
          routeFrom === "voucherHistory"
            ? !isVoucherExpired
              ? {}
              : {
                  backgroundColor: colors.background,
                }
            : {},
        ]}
      >
        {routeFrom === "voucherHistory" ? (
          !isVoucherExpired ? (
            <Button
              onPress={() => {
                setIsModalVisible(true)
              }}
              title={translate("voucherDetailScreen.useVoucher")}
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          ) : (
            <Text style={style.usedExpiredText}>
              {item?.use_at
                ? translate("voucherDetailScreen.usedOn")
                : translate("voucherDetailScreen.expiredOn")}
              {moment(item?.use_at ? item?.use_at : item?.end_date).format("DD-MM-YYYY • hh:mm")}
            </Text>
          )
        ) : (
          <>
            {routeFrom !== "redeemVoucher" && (
              <Text style={style.dontClickText}>
                {translate("voucherDetailScreen.dontClickVoucher")}
              </Text>
            )}
            <Button
              onPress={() => {
                if (point < item?.redeem_amt && routeFrom === "redeemVoucher") {
                  flash("error", translate("errors.failedToRedeem"))
                } else {
                  setIsModalVisible(true)
                }
              }}
              title={
                routeFrom === "redeemVoucher"
                  ? translate("voucherDetailScreen.redeem")
                  : translate("voucherDetailScreen.useVoucher")
              }
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          </>
        )}
      </View>
    </>
  )
}
